import type { Page, PageableInfoNew, TvChannel } from '@setplex/tria-api'

import { api } from '@setplex/tria-api'
import { combine, createEvent, createStore } from 'effector'
import { model as i18n } from '~/core/i18n'
import { genPagesLogicNew } from '~/shared/effector'
import { extendMediaItemByLabelPriceTvChannel } from '~/shared/tools'

export const resetPurchasedTvChannelsRow = createEvent()
export const $purchasedTvChannelsRow = createStore<Page<TvChannel> | null>(null)
  .on(api.tv.getPurchasedTvChannelsRowFx.doneData, (_, page) => page)
  .reset(resetPurchasedTvChannelsRow)

export const $purchasedTvChannelsRowFormatted = combine(
  $purchasedTvChannelsRow,
  i18n.$t,
  (purchasedTvChannelsRow) => ({
    ...purchasedTvChannelsRow,
    content: purchasedTvChannelsRow?.content.map((item) =>
      extendMediaItemByLabelPriceTvChannel(item)
    ),
  })
)

export const resetPurchasedTvChannelsGrid = createEvent()
export const $purchasedTvChannelsGrid = createStore<Page<TvChannel> | null>(
  null
)
  .on(api.tv.getPurchasedTvChannelsGridFx.doneData, (state, page) => {
    const currentTvChannels = state
      ? [...state.content, ...page.content]
      : page.content

    return {
      ...page,
      content: currentTvChannels,
    }
  })
  .reset(resetPurchasedTvChannelsGrid)

export const $purchasedTvChannelsGridFormatted = combine(
  $purchasedTvChannelsGrid,
  i18n.$t,
  (purchasedTvChannelsGrid) => {
    const formattedPageContent = purchasedTvChannelsGrid?.content.map((item) =>
      extendMediaItemByLabelPriceTvChannel(item)
    )

    return {
      ...purchasedTvChannelsGrid,
      content: formattedPageContent,
    }
  }
)

export const loadMorePurchasedTvChannelsGrid = genPagesLogicNew(
  $purchasedTvChannelsGrid.map((state) => {
    if (!state) return null

    const { last, first, number, size } = state
    const pageableInfo: PageableInfoNew = {
      last,
      first,
      number,
      size,
    }
    return pageableInfo
  }),
  api.tv.getPurchasedTvChannelsGridFx
)
